<template>
  <!-- 团购管理详情 -->
  <div class="advanced-form">
    <a-form>
      <div class="card">
        <div class="card-head">
          <h3>基础信息</h3>
        </div>
        <div class="card-body">
          <a-row type="flex">
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="店铺">
                <span class="ant-form-text">{{ goodsInfo.shopName }}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="商品名称">
                <span class="ant-form-text">{{ goodsInfo.title }}</span>
              </a-form-item>
            </a-col>
            <a-col v-if="type===1 || type===3" v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" v-if="type != 3">
                <div class="pic-box">
                  <img :src="goodsInfo.img" alt=""  @click="openImg(goodsInfo.img)" >
                </div>
              </a-form-item>
              <a-form-item class="value-indent" v-if="type == 3">
                <div class="pic-box">
                  <img :src="goodsInfo.goodsImgList&&goodsInfo.goodsImgList[0].fileUrl" alt=""  @click="openImg(goodsInfo.goodsImgList[0].fileUrl)" />
                </div>
                <div class="pic-boxs" v-show="goodsInfo.goodsImgList&&goodsInfo.goodsImgList.length>1">
                  <template v-for="(item ,i) in goodsInfo.goodsImgList">
                    <img :src="item.fileUrl" alt=""  @click="openImg(item.fileUrl)" v-if="i!=0 && i<5"  style="width: 48%;height: 48%;margin:2px;object-fit: cover;display: inline-block;"/>
                  </template>
                </div>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row type="flex">
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="发布时间">
                <span class="ant-form-text">{{ goodsInfo.createTime }}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="类型">
                <span class="ant-form-text">{{ type === 1 ? '团购' : type == 2?'代金券':'商品'  }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <!-- 团购 -->
          <a-row type="flex" v-if="type !=3">
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item v-if="type===1" class="value-indent" label="商品总价">
                <span class="ant-form-text">￥{{ goodsInfo.originalPrice }}</span>
              </a-form-item>
              <a-form-item v-else class="value-indent" label="面值">
                <span class="ant-form-text">￥{{ goodsInfo.originalPrice }}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="售价">
                <span class="ant-form-text">￥{{ goodsInfo.price }}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="有效期">
                <span class="ant-form-text">{{ goodsInfo.expireDesc }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <!-- 商品 -->
          <a-row type="flex" v-if="isProduct">
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="原价">
                <span class="ant-form-text">￥{{ goodsInfo.originalPrice}}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="售价">
                <span class="ant-form-text">￥{{ goodsInfo.price }}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="总库存">
                <span class="ant-form-text">{{ goodsInfo.stock }}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="运费">
                <span class="ant-form-text">￥{{ goodsInfo.freight }}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="服务承诺">
                <span class="ant-form-text">{{goodsInfo.serviceCommitment}}</span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </div>

      <div v-if="type===1" class="card">
        <div class="card-head">
          <h3>项目信息</h3>
        </div>
        <div class="card-body">
          <div v-for="(item) in goodsItems" v-bind:key=item.itemId>
            <div v-if="item.type===1" class="goodsItems-father">
              <div class="goodsItems-item">
                {{ item.title }}
              </div>
            </div>
            <div v-else class="goodsItems-children">
              <div class="goodsItems-item">
                · {{ item.title }}
              </div>
              <div v-if="item.type !==3" class="goodsItems-item">
                <!-- ({{ item.number }}{{item.unit}}) -->
              </div>
              <div v-if="item.type !==3" class="goodsItems-item">

                  <span class='card_txt'>({{ item.number }}{{item.unit}})</span><span class='card_txt'>￥{{ item.price }}</span>
              </div>
            </div>
          </div>
          <div style="width:33%;float:right"><span style="font-weight: bolder;position:relative;left:8px;"  class='card_txt'>总价值：</span><span  class='card_txt'>￥{{goodsInfo.originalPrice }}</span></div>
        </div>
      </div>

      <div v-if="type==3&&ruleDetails&&ruleDetails.spec1 != null" class="card">
        <div class="card-head">
          <h3>规格明细</h3>
        </div>
        <div class="card-body">
          <x-tabula
            ref="table"
            :searchList="[]"
            rowKey=""
            :columns="newColumns"
            :dataSource ="dataSource"
            :paginationParam="false"
            :rowSelection="false"
          >
          </x-tabula>
        </div>
      </div>

      <div v-if="type==3" class="card">
        <div class="card-head">
          <h3>图文详情</h3>
        </div>
        <div class="card-body" ref = 'htmlBox'>
        </div>
      </div>

      <div class="card">
        <div class="card-head">
          <h3>使用规则</h3>
        </div>
        <div class="card-body">
          <a-row type="flex" v-if='type!=3'>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="每次限用数量">
                <span class="ant-form-text">{{ goodsInfo.useMaxDesc }}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="是否免预约">
                <span class="ant-form-text">{{ goodsInfo.isAppointment === 1 ? '需预约' : '免预约' }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row type="flex" v-if='type!=3'>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="使用时间">
                <span class="ant-form-text">{{ goodsInfo.usableTimeDesc }}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="使用方式">
                <span class="ant-form-text">{{ goodsInfo.useType === 1 ? '到店消费' : '配送/上门' }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row type="flex">
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="其他规则">
                <span class="ant-form-text" style="word-break: break-all">{{ goodsInfo.otherRule }}</span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-form>

    <a-modal
      title="查看"
      :visible="visible"
      @cancel="visible = false"
      :footer="null"
      :maskClosable="true"
      :keyboard="true"
      destroyOnClose
      centered
      :width="800"
    >
      <div class="model-img"><img :src="img" alt="" /></div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'goodsDetail',
  data () {
    return {
      visible: false,
      img: undefined,
      ruleDetails: undefined,
      isProduct: false,
      type: undefined,
      goodsInfo: {},
      goodsItems: {},
      columns: [
        { title: '', dataIndex: 'spec1', align: 'center', width: '' },
        { title: '', dataIndex: 'spec2', align: 'center', width: '' },
        { title: '', dataIndex: 'spec3', align: 'center', width: '' },
        { title: '库存', dataIndex: 'stock', align: 'center', width: '' },
        { title: '价格', dataIndex: 'price', align: 'center', width: '', customCell: (row) => ({ domProps: { innerHTML: '￥' + row.price} })}
      ],
      newColumns: [],
      dataSource: []
    };
  },
  beforeRouteEnter (to, from, next) {
    next();
    setTimeout(() => {
      document.getElementsByClassName('layout-content')[0].style.padding = '0px';
      document.getElementsByClassName('layout-content')[0].style.backgroundColor = 'transparent';
    }, 0);
  },
  beforeRouteLeave (to, from, next) {
    document.getElementsByClassName('layout-content')[0].style.padding = '16px';
    document.getElementsByClassName('layout-content')[0].style.backgroundColor = '#fff';
    next();
  },
  created () {
    if (this.$route.query.type == 3) {
      this.isProduct = true;
    } else {
      this.isProduct = false;
    }
  },
  mounted () {
    if (this.$route.query.id) {
      this.getDetail();
    }
  },
  methods: {
    openImg (img) {
      this.img = img || '';
      this.visible = true;
    },
    traverseHeader () {
      this.ruleDetails && Object.keys(this.ruleDetails).forEach(key => {
        if (this.ruleDetails[key] && key != 'stock' && key != 'price') {
          let item = this.columns.filter(item => item.dataIndex == key)[0].title = this.ruleDetails[key];
        }
      });
      this.newColumns = this.columns.filter(item => item.title);
    },
    getDetail () {
      if (this.isProduct) {
        this.$get({
          url: `/local/goods/goodsInfo/${this.$route.query.id}`,
          params: {}
        }).then(({data}) => {
          this.type = data.goodsInfo.type;
          this.goodsInfo = data.goodsInfo;
          if (data && data.goodsItems) {
            this.goodsItems = data.goodsItems;
          }
          this.ruleDetails = data.ruleDetails;
          this.traverseHeader();
          setTimeout(() => {
            this.$refs.htmlBox.innerHTML = this.goodsInfo.detailHtml || '';
          }, 100);
        });
        this.$get({
          url: `/local/goods/goodsInfo/detailsList/${this.$route.query.id}`,
          params: {}
        }).then(({data}) => {
          this.dataSource = data;
        });
      } else {
        this.$get({
          url: `/local/goods/${this.$route.query.id}`,
          params: {}
        }).then(({data}) => {
          this.type = data.goodsInfo.type;
          this.goodsInfo = data.goodsInfo;
          if (data && data.goodsItems) {
            this.goodsItems = data.goodsItems;
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.model-img img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 800px;
  padding: 5px;
  margin:0 auto;
  display: block;
}
.card_txt{
  display: inline-block;
  width:100px;
  text-align: right;
}
.advanced-form .card .card-body .pic-box{
  width:200px;
  height: 200px !important;
  display: inline-block;
  height: initial;
  overflow: hidden;
  img{
    width:100%;
    height:100%;
    object-fit: cover;
  }

}
.pic-boxs{
  width:204px;
  height: 204px;
  display: inline-block;
  vertical-align: top;
  position: relative;
  top:-2px;
}

.goodsItems-father {
  display: flex;
  font-size: 14px;
  font-weight: bolder;
  padding-left: 10px;
}
.goodsItems-children{
  display: flex;
  padding-left: 20px;
}
.goodsItems-item{
  width: 33.33%;
}
</style>
